/**
 * @author: Raghav Prabhu
 */
// reactstrap components
import {
  Row,
  Col,
  Badge,
  ListGroupItem
} from "reactstrap";
import {
  csv, ipynb, image, defaultIcon, provisionerServiceList,
  RUN_PROGRESS_STATUS, RUN_EXECUTING_STATUS, RUN_COMPLETED_STATUS, RUN_FAILED_STATUS,
  RUN_CANCELLED_STATUS, STORAGE_JOB_VARIABLES
} from "./constants"
import { randomColor } from "randomcolor"
import defaultimg from "assets/img/df.png";

// svg image for services
import flataws from "./../../assets/img/aws.svg";
import flatgoogle from "./../../assets/img/gcloud.svg";
import flatazure from "./../../assets/img/azure.svg";
import flatpy from "./../../assets/img/flatpy.svg";
import spark from "./../../assets/img/spark.svg"


// Connectors asset images
import snowflakes from "assets/img/snowflakes.png";
import amazons3 from "assets/img/amazons3.svg";
import mongodb from "assets/img/mongodb.png";
import datalake from "assets/img/datalake.png";
import defaultconnector from "assets/img/link.png"
import toast from 'react-hot-toast';

const { convertCSVToArray } = require('convert-csv-to-array');
const converter = require('convert-csv-to-array');
const CSV = require('csv-string');




export const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach(
    (val) => val.length > 0 && (valid = false)
  );
  return valid;
}

export const countErrors = (errors) => {
  let count = 0;
  Object.values(errors).forEach(
    (val) => val.length > 0 && (count = count + 1)
  );
  return count;
}

export const getRandomRolor = () => {
  var colorcode = randomColor({
    luminosity: 'dark',
    format: 'rgba',
    alpha: 0.5
  });
  return colorcode;
}

export const disablePastDate = () => {
  const today = new Date();
  const dd = String(today.getDate() + 0).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};

export const fileSizeSI = (a, b, c, d, e) => {
  return (b = Math, c = b.log, d = 1e3, e = c(a) / c(d) | 0, a / b.pow(d, e)).toFixed(2)
    + ' ' + (e ? 'kMGTPEZY'[--e] + 'B' : 'bytes')
}

export const fileSizeIEC = (a, b, c, d, e) => {
  return (b = Math, c = b.log, d = 1024, e = c(a) / c(d) | 0, a / b.pow(d, e)).toFixed(2)
    + ' ' + (e ? 'KMGTPEZY'[--e] + 'iB' : 'Bytes')
}

export const imageFileExtension = (fileName) => {
  let ext = "";
  if (fileName !== null && fileName !== undefined) {
    ext = fileName.split('.').pop();
  }
  return ext;
}

export const CheckIsValidDomain = (domain) => {
  var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
  return re.test(domain);
}

export const millisecondToHour = (value, runstatus) => {
  let ms;
  const hourLimit = 3600000
  let hours = 0
  let minutes = 0
  if (value >= hourLimit) {
    // Hours & Minutes Conversion
    hours = Math.floor(value / hourLimit)
    minutes = (value % hourLimit) / 60 / 1000
  } else {
    // Minutes Conversion
    minutes = value / 60 / 1000
  }
  ms = <>
    {hours === 0 && <span></span>}
    {hours === 1 && <span><span>{timeConvertion(hours)}</span> hour </span>}
    {hours > 1 && <span><span>{timeConvertion(hours)}</span> hours </span>}

    {(minutes === 0 && runstatus === "Completed") && <span><span>{timeConvertion(minutes)}</span> min </span>}
    {minutes === 0 && runstatus === "Failed" && <span><span>{timeConvertion(minutes)}</span> min </span>}
    {minutes === 0 && <span></span>}
    {minutes === 1 && <span><span>{timeConvertion(minutes)}</span> min </span>}
    {minutes > 1 && <span><span>{timeConvertion(minutes)}</span> mins </span>}
  </>
  return ms;
}

const timeConvertion = (timeFormat) => {
  let time;
  if (timeFormat <= 9) {
    time = "0" + timeFormat
  } else {
    time = timeFormat
  }
  return time;
}

export const getImageFile = (ext) => {
  if (ext === "csv") {
    return csv;
  }
  else if (ext === "ipynb" || ext === "py" || ext === "log") {
    return ipynb;
  }
  else if (ext === "jpeg" || ext === "jpg" || ext === "png" || ext === "svg") {
    return image;
  } else {
    return defaultIcon;
  }
}


export const getRunTimeValues = () => {
  let RunTimeOptions = [
    {
      "name": "python38",
      "displayName": "Python3.8"
    }
  ];
  return RunTimeOptions;
}

export const getonCellRenderFocus = (state) => {
  if (state !== undefined) {
    var executeCellState = "markdownOutline_focus";
    if (state === "busy") {
      executeCellState = "markdownOutline_busy";
      return executeCellState;
    }

    else if (state === "idle") {
      executeCellState = "markdownOutline_focus"
      return executeCellState;
    }

    else if (state === "error") {
      executeCellState = "markdownOutline_error"
      return executeCellState;
    }

    else {
      return executeCellState;
    }
  }
}

export const findIcon = (contentType) => {
  if (!contentType) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg'
  } else if (contentType.startsWith('audio/')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/audio/mp3.svg'
  } else if (contentType.startsWith('image/')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/image/JPG.svg'
  } else if (contentType.endsWith('csv')) {
    return 'https://docs.webix.com/filemanager-backend/icons/small/document/csv.svg'
  } else if (contentType.startsWith('text/')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg'
  } else if (contentType.endsWith('pdf')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/document/pdf.svg'
  } else if (contentType.endsWith('xlsx')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/document/xlsx.svg'
  } else if (contentType.endsWith('zip')) {
    return 'https://docs.webix.com/filemanager-backend/icons/small/archive/zip.svg'
  } else if (contentType.endsWith('rar')) {
    return 'https://docs.webix.com/filemanager-backend/icons/small/archive/rar.svg'
  } else if (contentType.endsWith('less')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/code/less.svg'
  } else if (contentType.endsWith('docx')) {
    return ' https://docs.webix.com/docmanager-backend/icons/small/document/docx.svg'
  }
  else if (contentType.endsWith('jpeg') || contentType.endsWith('png') || contentType.endsWith('svg') ||
    contentType.endsWith('jpg')) {
    return 'https://docs.webix.com/docmanager-backend/icons/small/document/image.svg'
  }
  else {
    return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg'
  }
};

export const isJSON = (str) => {
  try {
    return (JSON.parse(str) && !!str);
  } catch (e) {
    return false;
  }
}

export const provisionerTypeLogo = (type) => {
  if (type === "AMAZON" || type === "AWS") {
    return flataws;
  }
  if (type === "GOOGLE") {
    return flatgoogle;
  }
  if (type === "AZURE") {
    return flatazure;
  }
  if (type === "PYTHON") {
    return flatpy;
  }
  if (type === "SPARK") {
    return spark;
  }

  if (type === undefined || type === null) {
    return defaultimg;
  }
}

export const cloudTypeLogo = (type) => {
  if (type === "AWS") {
    return flataws;
  }
  if (type === "GOOGLE") {
    return flatgoogle;
  }
  if (type === "AZURE") {
    return flatazure;
  }
  if (type === undefined || type === null) {
    return defaultimg;
  }
}

export const connectorsTypeLogo = (type) => {
  if (type === ("Snowflake" || "snowflake")) {
    return snowflakes;
  }
  if (type === "MongoDB") {
    return mongodb;
  }
  if (type === "AmazonS3") {
    return amazons3;
  }
  if (type === "Datalake") {
    return datalake;
  }
  if (type === undefined || type === null || type === "") {
    return defaultconnector;
  }
  else {
    return defaultconnector;
  }
}

export const ConnectorTypeUpdate = (type) => {
  if (type === ("Snowflake" || "snowflake")) {
    return <div style={{ marginLeft: 21 }}>
      <label htmlFor="Snowflakes">
        <img src={snowflakes} className="connectorImg" alt="Snowflakes" />
      </label>
      <br></br>
      <p style={{ fontSize: '12px', marginLeft: 5 }}><b>Snowflakes</b></p>
    </div>
  }
  if (type === "AmazonS3") {
    return <div style={{ marginLeft: 21 }}>
      <label htmlFor="Amazon S3">
        <img src={amazons3} className="connectorImg" alt="Amazon S3" />
      </label>
      <br></br>
      <p style={{ fontSize: '12px', marginLeft: 5 }}><b>Amazon S3</b></p>
    </div>
  }
  if (type === "MongoDB") {
    return <div style={{ marginLeft: 21 }}>
      <label htmlFor="MongoDB">
        <img src={mongodb} className="connectorImg" alt="MongoDB" />
      </label>
      <br></br>
      <p style={{ fontSize: '12px', marginLeft: 5 }}><b>MongoDB</b></p>
    </div>
  }
  if (type === "Datalake") {
    return <div style={{ marginLeft: 21 }}>
      <label htmlFor="Datalake">
        <img src={datalake} className="connectorImg" alt="Datalake" />
      </label>
      <br></br>
      <p style={{ fontSize: '12px', marginLeft: 5 }}><b>Datalake</b></p>
    </div>
  }
}

export const convertTextToTitleCase = (defaultText) => {
  let camelCaseText = defaultText
    .split(' ')
    .map(function (word, index) {
      // First character upper case else lower case
      return word.charAt(0)
        .toUpperCase() + word.slice(1)
          .toLowerCase();
    })
    .join(' ');
  return camelCaseText;
};

export const saveDownloadFile = (function () {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  return function (data, fileName) {
    const blob = new Blob([data], { type: "text/csv" }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName.replace(/\s/g, '');
    a.click();
    window.URL.revokeObjectURL(url);
  };
}());

export const getProvisionerServiceItem = (provisionerService) => {
  const serviceItem = provisionerServiceList.find(
    element => element.value === provisionerService || element.label === provisionerService
  )
  return serviceItem;
};

export const getProfilePicturebyEmail = (id, data, index) => {
  if (data.length !== 0) {
    var filterValue = data.filter(item => item.id === id);
    if (filterValue !== undefined) {
      return (<div className="avatar avatar-sm rounded-circle df-bg-info">
        {filterValue[0].photoURL === null ?
          <div><span>{filterValue[0].firstName[0] + filterValue[0].lastName[0]}</span></div>

          : <img src={filterValue[0].photoURL} alt={filterValue[0].firstName} style={{ borderRadius: '50px' }}
          />}

      </div>)
    }
  }

}

export const jobStatusAlert = (jobId, status, createdBy) => {
  toast((t) => (
    <span>
      <ListGroupItem className="border-0 p-1">
        <Row>
          <Col xs="2" className="successIcon">
            {status === RUN_PROGRESS_STATUS && <i className="fas fa-check-circle fa-2x df-text-yellow"></i>}
            {status === RUN_EXECUTING_STATUS && <i className="fas fa-check-circle fa-2x df-text-success"></i>}
            {status === RUN_COMPLETED_STATUS && <i className="fas fa-check-circle fa-2x df-text-primary"></i>}
            {status === RUN_CANCELLED_STATUS && <i className="fas fa-check-circle fa-2x df-text-secondary"></i>}
            {status === RUN_FAILED_STATUS && <i className="fas fa-check-circle fa-2x df-text-danger"></i>}

          </Col>
          {status === RUN_PROGRESS_STATUS && <Col xs="8" className="mt-2">
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" /> {status}</Badge> <br />
            <small className="font-weight-bold">New Job Created</small> <br />
            <small className="">Created By : </small><small className="font-weight-bold">{createdBy}</small>
          </Col>}

          {status === RUN_EXECUTING_STATUS && <Col xs="8" className="mt-2">
            <Badge color="" className="badge-dot"><i className="bg-success blink" />{status}</Badge><br />
            <small className="">Job Id : </small><small className="font-weight-bold">{jobId}</small><br />
            <small className="">Created By : </small><small className="font-weight-bold">{createdBy}</small>
          </Col>}

          {status === RUN_COMPLETED_STATUS && <Col xs="8" className="mt-2">
            <Badge color="" className="badge-dot"><i className="bg-primary" />{status}</Badge><br />
            <small className="">Job Id : </small><small className="font-weight-bold">{jobId}</small><br />
            <small className="">Created By : </small><small className="font-weight-bold">{createdBy}</small>
          </Col>}

          {status === RUN_CANCELLED_STATUS && <Col xs="8" className="mt-2">
            <Badge color="" className="badge-dot"><i className="bg-secondary" />{status}</Badge><br />
            <small className="">Job Id : </small><small className="font-weight-bold">{jobId}</small><br />
            <small className="">Created By : </small><small className="font-weight-bold">{createdBy}</small>
          </Col>}

          {status === RUN_FAILED_STATUS && <Col xs="8" className="mt-2">
            <Badge color="" className="badge-dot"><i className="bg-danger" />{status}</Badge><br />
            <small className="">Job Id : </small><small className="font-weight-bold">{jobId}</small><br />
            <small className="">Created By : </small><small className="font-weight-bold">{createdBy}</small>
          </Col>}

          <Col xs="2" className="actionicon border-left" onClick={e => toast.dismiss(t.id)}>
            <i className="fas fa-times"></i>
          </Col>
        </Row>
      </ListGroupItem>
    </span>
  ));
}


export const storagejobStatusAlert = (noteData) => {
  toast((t) => (
    <span>
      <ListGroupItem className="border-0 p-1">
        <Row>
          <Col xs="2" className="successIcon">
            {noteData.jobState === "FINISHED" && <i className="fas fa-check-circle fa-2x df-text-success"></i>}
            {noteData.jobState === "FAILED" && <i className="fas fa-exclamation-circle fa-2x df-text-danger"></i>}
          </Col>

          {(noteData.jobType === STORAGE_JOB_VARIABLES.MOVE || noteData.jobType === STORAGE_JOB_VARIABLES.COPY) && <Col xs="8" className="mt-2">
            <small className="font-weight-bold">
              {noteData.jobType === STORAGE_JOB_VARIABLES.MOVE ? "Moved Successfully" : "Copied Successfully"}</small> <br />
            <small className="">Source Path : </small><small title={noteData.sourcePath}
              className="font-weight-bold text-primary overflow-toast">{noteData.sourcePath}</small><br />
            <small className="">Destination Path: </small>
            <small title={noteData.destinationPath} onClick={e => OpenStorageView(noteData.destinationPath, e)}
              className="font-weight-bold text-primary overflow-toast actionicon">{noteData.destinationPath}</small>
          </Col>}

          {noteData.jobType === STORAGE_JOB_VARIABLES.RENAME && <Col xs="8" className="mt-1">
            <small className="font-weight-bold">Renamed Successfully</small> <br />
          </Col>}

          {noteData.jobType === STORAGE_JOB_VARIABLES.MOVE_TO_TRASH && <Col xs="8" className="mt-2">
            <small title={noteData.sourcePath} className="font-weight-bold text-primary overflow-toast actionicon">{noteData.sourcePath}</small>&nbsp;<small className="font-weight-bold">Moved to trash Successfully</small><br />
          </Col>}

          {noteData.jobType === STORAGE_JOB_VARIABLES.RESTORE && <Col xs="8" className="mt-2">
            <small>Restored Successfully to this path</small>&nbsp;<small title={noteData.sourcePath} className="font-weight-bold text-primary overflow-toast actionicon">{noteData.sourcePath}</small><br />
          </Col>}

          {noteData.jobType === STORAGE_JOB_VARIABLES.FILE_EXTRACTION && <Col xs="8" className="mt-2">
            <small title={noteData.sourcePath} className="font-weight-bold text-primary overflow-toast actionicon">{noteData.sourcePath}</small>&nbsp;<small className="font-weight-bold">Extracted Successfully</small><br />
          </Col>}

          {noteData.jobType === STORAGE_JOB_VARIABLES.VERSION && <Col xs="8" className="mt-2">
            <small title={noteData.sourcePath} className="font-weight-bold text-primary overflow-toast actionicon">{noteData.sourcePath}</small>&nbsp;<small className="font-weight-bold">File Updated Successfully</small><br />
          </Col>}
          <Col xs="2" className="actionicon border-left" onClick={e => toast.dismiss(t.id)}>
            <i className="fas fa-times"></i>
          </Col>
        </Row>
      </ListGroupItem>
    </span>
  ));
}



const OpenStorageView = (path, event) => {
  event.preventDefault()
  let finalPath = path.slice(-1) === "/" ? "/storage?path=" + path : ""; // check folder or file
  let redirectUrl = window.location.origin + finalPath;
  window.open(redirectUrl, "_blank");
}

export const convertOBJToCSV = (data) => {
  if (data.length > 0) {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));
    // Loop to get value of each objects key
    for (const row of data) {
      const values = headers.map(header => {
        const val = row[header]
        return `"${val}"`;
      });
      // To add, sepearater between each value
      csvRows.push(values.join(','));
    }
    return csvRows.join('\n');
  }
}

export const CSVToJSON = (csv) => {
  if (csv !== undefined && csv !== null) {
    const lines = csv.split('\n')
    const result = []
    const headers = lines[0].split(',')
    lines.map(l => {
      const obj = {}
      const line = l.split(',')
      headers.map((h, i) => {
        obj[h] = line[i]
      })
      result.push(obj)
    })
    return result
  }
}


function CSVToArray(csvData, delimiter) {
  delimiter = (delimiter || ",");
  var pattern = new RegExp((
    "(\\" + delimiter + "|\\r?\\n|\\r|^)" +
    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
    "([^\"\\" + delimiter + "\\r\\n]*))"), "gi");
  var data = [[]];
  var matches = null;
  while (matches = pattern.exec(csvData)) {
    var matchedDelimiter = matches[1];
    if (matchedDelimiter.length && (matchedDelimiter != delimiter)) {
      data.push([]);
    }
    if (matches[2]) {
      var matchedDelimiter = matches[2].replace(
        new RegExp("\"\"", "g"), "\"");
    } else {
      var matchedDelimiter = matches[3];
    }
    data[data.length - 1].push(matchedDelimiter);
  }
  return (data);
}

export const CSVToJSONs = (csvData, delimiter) => {
  return CSV.parse(csvData, delimiter, '"')
}

export const arrayToCSV = (data) => {
  var csv = ""
  if (data !== undefined && data !== null) {
    for (let record = 0; record < data.length; record++) {
      var row = data[record];
      var records = "";

      for (let index = 0; index < row.length; index++) {
        var item = row[index];
        if (item === null) {
          item = "";
        }
        //Add Single quotes if item is number
        if (typeof (item) !== 'number') {
          if (item !== undefined && item !== null && item !== "") {
            item = item.replaceAll("\"", "'")
          }
          //Add quotes if item have comma
          if ((item !== undefined && item !== null && item !== "") && (item.match(","))) {
            item = "\"" + item + "\"";
          }
        }
        records += item;
        if (index != row.length - 1) {
          records += ",";
          // If the element is not the last element , then add a comma
        }
      }
      records += "\n";
      csv += records;
    }
  }
  return csv

}


export const removeIndexFromPath = (path) => {
  let pathValue = undefined;
  if (path !== undefined && path !== null) {
    pathValue = path.substring(
      path.indexOf('_') + 1
    )
  }
  return pathValue;
}

export const addDisableScroll = () => {
  var elements = document.getElementsByClassName('main-panel');
  for (var index = 0; index < elements.length; index++) {
    elements[index].classList.add("disable-scroll");
  }
}

export const removeDisableScroll = () => {
  var elements = document.getElementsByClassName('main-panel');
  for (var index = 0; index < elements.length; index++) {
    elements[index].classList.remove("disable-scroll");
  }
}

export const getColID = (cellNum) => {
  let columnLetter = ""
  while (cellNum > 0) {
    let t = (cellNum - 1) % 26;
    columnLetter = String.fromCharCode(65 + t) + columnLetter;
    cellNum = (cellNum - t) / 26 | 0;
  }
  return columnLetter || undefined
}

export const getColName = (tableData, state, noOfRecords, isHeader = true) => {
  let colName;
  let col;
  let headerRow = 0;
  if (isHeader) {
    headerRow = 1;
  }
  if (tableData && 0 < tableData.length && state) {
    if (tableData[0][0]) {
      col = getColID(tableData[0][1] + 1);
      return colName = col + (((state.activePage - 1) * noOfRecords) + headerRow + tableData[0][0]);
    }
  }
  return "";
}
